import client from './client';
import qs from 'qs';
const employeeUrl = '/api/v1/user';
const hrGradeUrl = '/api/v1/common/hrGrade';
const hrDptUrl = '/api/v1/common/hrDpt';
const hrResumeUrl = '/api/v1/common/hrResume';
const approvalUrl = '/api/v1/common/approval';

//유저 리스트 가져오기
export const getEmployees = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${employeeUrl}/list?${queryString}`);
};

export const getEmployee = (id) => {
  return client.get(`${employeeUrl}/info/${id}`);
};

//유저 정보 추가
export const addEmployee = (dataToSubmit) => {
  return client.post(`${employeeUrl}/info`, dataToSubmit);
};

//유저 정보 수정
export const editEmployee = (dataToSubmit) => {
  return client.put(
    `${employeeUrl}/info/${dataToSubmit.usrUuid}`,
    dataToSubmit,
  );
};

// 비밀번호 초기화
export const initEmpPwd = (id) => {
  return client.put(`${employeeUrl}/changePwd/${id}/default`);
};

export const removeEmployee = (id) => {
  return client.delete(`${employeeUrl}/info/${id}`);
};

//직급 가져오기
export const getHrGrade = (params) => {
  const queryString = qs.stringify(params);
  return client.get(`${hrGradeUrl}/list?${queryString}`);
};

//마지막 부서 가져오기
export const getHrDptEnd = (params) => {
  // const queryString = qs.stringify(params);
  return client.get(`${hrDptUrl}/list/end`);
};

//본부 부서 가져오기
export const getHrHq = (params) => {
  // const queryString = qs.stringify(params);
  return client.get(`${hrDptUrl}/list/hq`);
};


//hr정보 가져오기
export const getHrResMasByGroup = (group) => {
  const queryString = qs.stringify(group);

  return client.get(`${hrResumeUrl}/resMasByGroup?${queryString}`);
};

//hr attr 가져오기
export const getHrResAttrByType = (type) => {
  const queryString = qs.stringify(type);

  return client.get(`${hrResumeUrl}/resAttrsByTyp?${queryString}`);
};

//emplyoee infoTyp별 가져오기
export const getResumeByEmp = (params) => {
  return client.get(
    `${hrResumeUrl}/list/${params.id}?infoTyp=${params.infoTyp}`,
  );
};

//개인별 자격증
export const addResumeLicenseByEmp = (formData) => {
  return client.post(`${hrResumeUrl}/info/file`, formData, {
    header: { 'Content-type': 'multipart/form-data' },
  });
  //return client.post(`${hrResumeUrl}/info/file`, dataToSubmit);
};

export const addResumeByEmp = (dataToSubmit) => {
  return client.post(`${hrResumeUrl}/info`, dataToSubmit);
};

export const editResumeByEmp = (dataToSubmit) => {
  return client.put(
    `${hrResumeUrl}/info/${dataToSubmit.infoUuid}`,
    dataToSubmit,
  );
};

export const removeResumeByEmp = (id) => {
  return client.delete(`${hrResumeUrl}/info/${id}`);
};

//사용자 결재선리스트 가져오기
export const getApprovalLine = () => {
  return client.get(`${approvalUrl}/line/list`);
};

export const getInvoiceApprovalLine = () => {
  return client.get(`${approvalUrl}/line/list/invoice`);
};

//결재선 등록
export const addApprovalLine = (dataToSubmit) => {
  return client.post(`${approvalUrl}/line`, dataToSubmit);
};
//결재선 수정
export const editApprovalLine = (dataToSubmit) => {
  return client.put(
    `${approvalUrl}/line/${dataToSubmit.apprUuid}`,
    dataToSubmit,
  );
};

//결재선 삭제
export const removeApprovalLine = (id) => {
  return client.delete(`${approvalUrl}/line/${id}`);
};
